export default {
	vendorList: [],
	objVendorEdit: [],
	vendorManufacturers: [],
	vendorManufacturerRanges: [],
	vendorManufacturerLinks: [],
	objVendorSelectEdit: [],
	objAppRanges: [],
  vendorsIni: 0,
  manufacturerAudits: [],
  vendorDepartmentBranches: []
}
